import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {Moment} from 'moment-timezone';
import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';


export class PrescriptionSummaryModel implements SummaryModel{
    id: number;
    permissions: PermissionsModel;
    date: Moment;
    partner: PartnerSummaryModel;
    document: DocumentSummaryModel;
}
